module.exports = __webpack_public_path__ + "media/question5_en.f5de9b28.mp3";